import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Survey } from 'survey-react-ui';
import { StylesManager, Model } from 'survey-core';
import axios from 'axios';
import SurveyProp from '../../sections/survey/propTypes/surveyProp';
import Notifications from '../../services/notifications';
import SkipStepButton from '../../sections/journey/overall/content/components/SkipStepButton';

export default function SurveyJSContainer({
  _csrf,
  survey,
  contextId,
  backURL,
  onDone,
  onSkipStep,
}) {
  // Make sure that it's only shown if the React side is rendered
  const [showSurveyJS, setShowSurveyJS] = useState(false);
  const [surveyData, setSurveyData] = useState({});

  // Send answers to api
  const sendAnswers = answersData => {
    const url = `/api/survey/externalProvider/${survey._id}/submit?surveyContext=${contextId}`;
    const params = {
      provider: 'surveyjs', // Static because this component is only for surveyjs,
      answersData, // answers
    };
    axios
      .post(url, params, {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'X-CSRF-Token': _csrf,
          _csrf,
        },
      })
      .then(() => {
        if (onDone) {
          onDone();
        } else {
          window.location.href = backURL || '/dashboard'; // Same behavior as surveys by BRAVON
        }
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err, 'error_submitSurveyjs');
        console.log(err);
      });
  };

  // Handle completion of survey
  const alertResults = useCallback(sender => {
    sendAnswers(sender.data);
  }, []);

  useEffect(() => {
    // Apply the theme
    StylesManager.applyTheme('modern');
    // Make sure that it's only shown if the React side is rendered
    setShowSurveyJS(true);
    // Update the survey state to the correct data
    setSurveyData(new Model(survey.providerData));
  }, []);

  // If survey is well rendered it should have the onComplete param
  // if so, added the function to handle data after survey is finished
  if (surveyData.onComplete) {
    surveyData.onComplete.add(alertResults);
  }

  return (
    <div className="course-quiz-wrapper">
      <div className="m-portlet m-portlet--rounded">
        <div className="m-portlet__body">
          {onSkipStep && (
            <div className="skip-wrapper m-0">
              <SkipStepButton onClick={onSkipStep} />
            </div>
          )}
          {showSurveyJS && <Survey model={surveyData} />}
        </div>
      </div>
    </div>
  );
}

SurveyJSContainer.propTypes = {
  survey: PropTypes.shape(SurveyProp.propType).isRequired,
  _csrf: PropTypes.string.isRequired,
  contextId: PropTypes.string.isRequired,
  backURL: PropTypes.string,
  onDone: PropTypes.func,
  onSkipStep: PropTypes.func,
};

SurveyJSContainer.defaultProps = {
  backURL: null,
  onDone: null,
  onSkipStep: null,
};
